const initCartMobileSticky = () => {
  const update = () => {
    const sticky = document.querySelector('.cart-summary__mobile-sticky');
    const summary = document.querySelector('.cart-top-picks__mobile-summary');
    const acceleratedCheckoutButtons = document.querySelectorAll('[data-accelerated-checkout-buttons]');
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    acceleratedCheckoutButtons.forEach((buttons) => {
      const verticalState = String(isMobile);
      if (buttons.dataset.acceleratedCheckoutVertical === verticalState) return;

      buttons.classList.toggle('additional-checkout-buttons--vertical', isMobile);
      buttons.dataset.acceleratedCheckoutVertical = verticalState;

      const checkout = buttons.querySelector('shopify-accelerated-checkout-cart');
      if (checkout) checkout.replaceWith(checkout.cloneNode(true));
    });

    if (!sticky || !summary) return;

    const summaryTop = summary.getBoundingClientRect().top;
    const hideAt = window.innerHeight - sticky.offsetHeight - 12;
    const isPastSummary = summaryTop <= hideAt;

    document.body.classList.toggle('cart-mobile-sticky-controlled', isMobile);
    document.body.classList.toggle('cart-mobile-sticky-visible', isMobile && !isPastSummary);
    document.body.classList.toggle('cart-mobile-sticky-after-summary', isMobile && isPastSummary);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  document.addEventListener('cart:update', () => setTimeout(update, 0));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartMobileSticky, { once: true });
} else {
  initCartMobileSticky();
}
